/* eslint-disable @typescript-eslint/no-explicit-any */
import { Grid, Paper } from "@mui/material";
import React from "react";
import { UserService } from "services";
import { zodResolver } from "@hookform/resolvers/zod";
import { FieldErrors, FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { z } from "zod";
import { useResetPasswordForm } from "hooks";
import {
    SubmitButton,
    FormTextInput,
    ErrorDisplay
} from "components";
import { CoreRoutes } from "app-constants";
import { ResetPasswordFormProps } from "./ResetPasswordFormProps";

export const ResetPasswordForm = ({ email, token }: ResetPasswordFormProps) => {
    const navigate = useNavigate();
    const { schema } = useResetPasswordForm();
    type FormFields = z.infer<typeof schema>;
    const methods = useForm<FormFields>({
        defaultValues: { email: email ?? '', token: token ?? '' },
        resolver: zodResolver(schema),
        mode: 'onBlur',
    });

    const onSubmit = async (data: FormFields) => {
        try {
            await UserService.resetPassword(data.email, data.token, data.password);
            navigate(CoreRoutes.home);
        } catch (e: any) {
            methods.setError('root', { type: 'manual', message: e.message });
        }
    };
    const onError = async (data: FieldErrors<FormFields>) => {
        console.log(data);
    };
    return (
        <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(onSubmit, onError)} style={{ width: '25%', height: '80%' }}>
                <Grid container justifyContent='center' spacing={2} component={Paper} p={2}>
                    <Grid item xs={12} textAlign={'start'} py={1}>
                        <ErrorDisplay message={methods.formState?.errors?.root?.message} />
                    </Grid>
                    <Grid item xs={12} textAlign={'center'}>
                        <FormTextInput name='password' type='password' />
                    </Grid>
                    <Grid item xs={12} textAlign={'center'}>
                        <FormTextInput name='confirmPassword' type='password' />
                    </Grid>
                    <Grid item xs={12} textAlign={'center'}>
                        <SubmitButton text="Reset Password" />
                    </Grid>
                </Grid>
            </form>
        </FormProvider>
    );
}